import React from "react";
import CheckboxField from "../../../../pages/shared/components/formik/checkbox";
import CustomList from "../../list";
import CustomListItem from "../../list/list-item";
import CustomLink from "../../link";
import CheckboxContainer from "../../../layout/page/forms-container/form-item-container/checkbox-container";
import { useMessageSource } from "react-message-source";
import { Term } from "iam-client/dist/client/shared/termsOfServices";

interface TermsOfServiceCheckboxInterface {
  terms: Term[];
}

const TermsOfServiceCheckbox = (
  props: TermsOfServiceCheckboxInterface,
): React.JSX.Element => {
  const { terms } = props;
  const { getMessage } = useMessageSource();

  return (
    <CheckboxContainer>
      <CheckboxField
        forceReRender
        name="acceptTermsAndConditions"
        label={
          <span className={`checkbox-text`}>
            {getMessage("TermsAndConditions.accept-1")}
            {terms.length > 1 && (
              <CustomList>
                {terms.map((item, index) => {
                  return (
                    <CustomListItem key={index}>
                      <CustomLink href={item.url} target={"_blank"} noicon>
                        {item.label}
                      </CustomLink>
                    </CustomListItem>
                  );
                })}
              </CustomList>
            )}
            {terms.length === 1 && (
              <CustomLink href={terms[0].url} target={"_blank"} noicon>
                {terms[0].label}
              </CustomLink>
            )}
            {getMessage("TermsAndConditions.accept-2")}
          </span>
        }
      />
    </CheckboxContainer>
  );
};

export default TermsOfServiceCheckbox;
